import { render, staticRenderFns } from "./MainCmp.vue?vue&type=template&id=59581d13&scoped=true&"
import script from "./MainCmp.vue?vue&type=script&lang=js&"
export * from "./MainCmp.vue?vue&type=script&lang=js&"
import style0 from "./MainCmp.vue?vue&type=style&index=0&id=59581d13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59581d13",
  null
  
)

export default component.exports